import {CanActivateFn, Router} from '@angular/router';
import {inject} from "@angular/core";
import {map, switchMap} from "rxjs";
import {AuthService} from "../services/auth.service";
import Relation from "../model/relation.model";
import RelationContact from "../model/relation-contact.model";
import {config} from "../../../config";
import {Ticket} from "../model/ticket.model";

export const RelationContactHasNotReachedMaximumTicketsGuard: CanActivateFn = () => {
  const authService: AuthService = inject(AuthService);
  const router: Router = inject(Router);

  /**
   * @description check if the currently active relation has reached the maximum amount of tickets
   * @file packages/hgvt/mijnomgeving/src/UI/src/config.ts - Configuration file for the application
   * @file packages/hgvt/mijnomgeving/src/UI/src/mijntrined.prod.config.ts - Production configuration file for the application
   */
  return authService.getUser(['relations.tickets']).pipe(
    switchMap((user: RelationContact | null) => {
      if (!user) {
        return [false]; // Geen gebruiker gevonden
      }

      return authService.getActiveRelation().pipe(
        map((relation: Relation | null) => {
          if (!relation) {
            return false; // Geen relatie gevonden
          }

          if (!relation.tickets) {
            return true; // Geen relatie of tickets betekent geen beperking
          }

          const ticketCount: number = relation.tickets.filter((ticket: Ticket) =>
            ticket.state_description === 'new'
            || ticket.state_description === 'pending'
          ).length || 0;

          if (ticketCount >= config.maxTicketsPerRelation) {
            router.navigateByUrl('/dashboard/customersupport/tickets');
            return false; // Te veel tickets
          }

          return true; // Toegang toegestaan
        })
      );
    })
  );
}
